import React from "react";
import { Search } from "/app/src/components/generic/components/search";

/**
 * Filters component that renders a search filter.
 * @param {Object} props - The component properties.
 * @param {function} props.setSearchString - Function to update the search string.
 * @returns {JSX.Element} The rendered search filter component.
 */
export default function Filters({
  setSearchString,
}: {
  setSearchString: (searchString: string) => void;
}) {
  return (
    <div className="workflowFilters">
      <Search setSearchString={setSearchString} />
    </div>
  );
}
